import { STATUS_TYPE } from '../../../enum';

export interface GetCategory {
  id: string;
}

export interface FindCategory {
  search?: string;
  limit?: number;
  skip?: number;
}

export interface CreatePatchCategory {
  id?: string;
  labelEn: string;
  labelAr: string;
  emoji: string;
  descriptionEn: string;
  descriptionAr: string;
  imgUrl: string;
  // itemsSortType: string;
  position: string;
  activeState: boolean;
  isPrimary: boolean;
}

export interface Category {
  id: string;
  labelEn: string;
  labelAr: string;
  emoji: string;
  descriptionEn: string;
  descriptionAr: string;
  imgUrl: string;
  // itemsSortType: string;
  position: string;
  isPrimary: boolean;
  activeState: boolean;
  createdBy: string;
  updatedBy: string;
  updatedAt: string;
  createdAt: string;
}

interface InitialState {
  data: Category[];
  skip: number;
  limit: number;
  totalRecords: number;
  currentPage: number;
  status: STATUS_TYPE;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
}

export const initialState: InitialState = {
  data: [],
  skip: 0,
  limit: 25,
  totalRecords: 0,
  currentPage: 0,
  status: 'idle',
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
};
